import { formatMoney } from '@expenditure/core';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';
import { Avatar, ErrorState, PageHeader, PageSkeleton } from '../components/ui';
import { errorMessage } from '../lib/format';
import { useBalances } from '../lib/queries';
import { Icon } from '../components/Icon';

export function BalancesPage() {
  const { groupId = '' } = useParams();
  const { t } = useTranslation();
  const { data, isPending, error, refetch } = useBalances(groupId);

  if (isPending) return <PageSkeleton />;
  if (error) return <ErrorState message={errorMessage(error, t)} onRetry={() => void refetch()} />;

  const { currency, balances, myMemberId } = data;
  const largest = Math.max(1, ...balances.map((b) => Math.abs(b.netMinor)));
  const sorted = [...balances].sort((a, b) => b.netMinor - a.netMinor);

  return (
    <main className="page page--no-tabbar app">
      <PageHeader title={t('balances.title')} />
      <div className="card card--flush list">
        {sorted.map((b) => {
          const amount = formatMoney(Math.abs(b.netMinor), currency);
          const width = `${(Math.abs(b.netMinor) / largest) * 100}%`;
          return (
            <div className="list-row" key={b.memberId} style={{ cursor: 'default', alignItems: 'flex-start' }}>
              <Avatar name={b.member.displayName} photo={b.member.profilePhoto} />
              <div className="grow">
                <div className="row" style={{ justifyContent: 'space-between' }}>
                  <span className="list-title ellipsis">
                    {b.member.displayName}
                    {b.memberId === myMemberId && <span className="muted"> ({t('common.you')})</span>}
                  </span>
                  <span className={`small num ${b.netMinor > 0 ? 'pos' : b.netMinor < 0 ? 'neg' : 'muted'}`} style={{ fontWeight: 700 }}>
                    {b.netMinor > 0
                      ? t('balances.getsBack', { amount })
                      : b.netMinor < 0
                        ? t('balances.owes', { amount })
                        : t('balances.settled')}
                  </span>
                </div>
                <div className="list-sub num">
                  {t('balances.paid')} {formatMoney(b.paidMinor, currency)} · {t('balances.share')}{' '}
                  {formatMoney(b.shareMinor, currency)}
                </div>
                <div className="bar" aria-hidden>
                  <span
                    style={{
                      width,
                      background: b.netMinor >= 0 ? 'var(--positive)' : 'var(--negative)',
                    }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <Link className="btn btn--primary btn--block" to={`/groups/${groupId}/settle`}>
        <Icon name="swap" size={18} />
        {t('group.settleUp')}
      </Link>
    </main>
  );
}
